import * as React from 'react';
import classNames from 'classnames';
import { IFieldBaseProperties } from './interfaces';

export default class FieldBase extends React.PureComponent<IFieldBaseProperties> {
  render() {
    let divClasses = classNames({
      "hcs-field": true,
      "w-full": true,
      [`hcs-${this.props.type}`]: true
    });

    let labelClasses = classNames({
      "w-full": true,
      [`hcs-${this.props.type}__label`]: true
    });

    let labelTextClasses = classNames({
      required: this.props.required === true
    });

    return <div key={this.props.id + "_fieldContainer"} className={divClasses}>
      <label key={this.props.id + "_label"} className={labelClasses} htmlFor={this.props.id}>
        <span key={this.props.id + "_label_text"} className={labelTextClasses}>{this.props.label}</span>
      </label>
      {this.props.children}
    </div>;
  }
}